$(document).on("click",".wetheme-dropdown__wrapper li",function() {
    var text = '';
    $('.wetheme-dropdown__wrapper span').each(function(){
        text += $(this).text() + ' ';
    });
   var main_text = text.trim();
    $('.product-form__variants option').each(function(){
        var value = $(this).attr('variant-title').trim(); 
      if(main_text == value){
         var datavalue = $(this).attr('data-price');
        if(datavalue == undefined || datavalue == ''){          
          $('.product-info-wrapper .inventoryNote.form__label').text('');
        }else{         
           $('.product-info-wrapper .inventoryNote.form__label').text(datavalue);
        }
          
      }else{
          
      }
    });
});